type Tone = 'success' | 'error' | 'info';
class ToastManager {
  show(message: string, tone: Tone = 'info'): void {
    let host = document.querySelector<HTMLElement>('#toast-host');
    if (!host) { host = document.createElement('div'); host.id = 'toast-host'; host.className = 'toast-host'; document.body.append(host); }
    const item = document.createElement('div'); item.className = `toast toast--${tone}`; item.textContent = message; host.append(item);
    requestAnimationFrame(() => item.classList.add('is-visible'));
    setTimeout(() => { item.classList.remove('is-visible'); setTimeout(() => item.remove(), 250); }, 3500);
  }
}
export const toast = new ToastManager();
